import { jsx, jsxs } from 'react/jsx-runtime';
import { countActiveFilters } from '../../utils/buildFilterWhere.js';
import 'date-fns-tz';
import 'clsx';
import 'tailwind-merge';
import { Button } from '../page-layout/Button.js';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import { Badge } from '../ui/badge.js';
import { Filter, X } from 'lucide-react';
import { useState, useEffect, useCallback } from 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import { DatePicker } from '../ui/date-picker.js';
import { Label } from '../ui/label.js';
import { Input } from '../ui/input.js';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-popover';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetFooter } from '../ui/sheet.js';
import '../ui/sidebar.js';
import 'react-toastify';
import { Switch } from '../ui/switch.js';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import './CrudDetailView.js';
import './CrudFormView.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@clerk/clerk-react';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import '../../lib/toast.js';
import { MultiSelectCombobox } from '../form/MultiSelectCombobox.js';
import '../form/RichTextEditor.js';
import { SearchableDropdown } from '../form/SearchableDropdown.js';

function ListFilters({ filters, filterState, onFilterChange, onClear, open, onOpenChange, }) {
    // Local draft state — only applied when user clicks "Apply Filters"
    const [draft, setDraft] = useState(filterState);
    // Sync draft when the sheet opens or external filterState changes while closed
    useEffect(() => {
        if (open) {
            setDraft(filterState);
        }
    }, [open]);
    const updateDraft = useCallback((key, value) => {
        setDraft(prev => ({ ...prev, [key]: value }));
    }, []);
    const handleApply = useCallback(() => {
        onFilterChange(draft);
        onOpenChange(false);
    }, [draft, onFilterChange, onOpenChange]);
    const handleClear = useCallback(() => {
        setDraft({});
        onClear();
    }, [onClear]);
    const draftActiveCount = countActiveFilters(draft);
    return (jsx(Sheet, { open: open, onOpenChange: onOpenChange, children: jsxs(SheetContent, { side: "right", className: "sm:max-w-md w-full", children: [jsxs(SheetHeader, { children: [jsxs(SheetTitle, { className: "flex items-center gap-2", children: [jsx(Filter, { className: "h-4 w-4" }), "Filters", draftActiveCount > 0 && (jsx(Badge, { variant: "secondary", className: "h-5 min-w-5 px-1.5 text-xs rounded-full", children: draftActiveCount }))] }), jsx(SheetDescription, { children: "Narrow down results by applying filters." })] }), jsx("div", { className: "flex-1 overflow-y-auto px-4 space-y-5", children: filters.map(filter => (jsx(FilterControl, { filter: filter, value: draft[filter.key], onChange: value => updateDraft(filter.key, value) }, filter.key))) }), jsx(SheetFooter, { children: jsxs("div", { className: "flex flex-col-reverse sm:flex-row sm:justify-end gap-3 w-full", children: [jsxs(Button, { variant: "outline", onClick: handleClear, disabled: draftActiveCount === 0, children: [jsx(X, { className: "h-4 w-4 mr-1.5" }), "Clear All"] }), jsx(Button, { onClick: handleApply, children: "Apply Filters" })] }) })] }) }));
}
function FilterControl({ filter, value, onChange }) {
    switch (filter.type) {
        case 'multiselect':
            return (jsxs("div", { className: "space-y-1.5", children: [jsx(Label, { className: "text-sm font-medium", children: filter.label }), jsx(MultiSelectCombobox, { options: filter.options, value: value || [], onChange: onChange, placeholder: `All ${filter.label}` })] }));
        case 'relation':
            return (jsxs("div", { className: "space-y-1.5", children: [jsx(Label, { className: "text-sm font-medium", children: filter.label }), jsx(SearchableDropdown, { endpoint: filter.endpoint, labelField: filter.labelField, valueField: filter.valueField, value: value || '', onChange: onChange, placeholder: `All ${filter.label}` })] }));
        case 'text':
            return (jsxs("div", { className: "space-y-1.5", children: [jsx(Label, { className: "text-sm font-medium", children: filter.label }), jsx(Input, { value: value || '', onChange: e => onChange(e.target.value), placeholder: filter.placeholder || `Filter by ${filter.label.toLowerCase()}...` })] }));
        case 'boolean':
            return (jsxs("div", { className: "space-y-1.5", children: [jsx(Label, { className: "text-sm font-medium", children: filter.label }), jsx("div", { className: "flex items-center h-9", children: jsx(Switch, { checked: value === true, onCheckedChange: checked => onChange(checked || undefined) }) })] }));
        case 'presence':
            return (jsxs("div", { className: "space-y-1.5", children: [jsx(Label, { className: "text-sm font-medium", children: filter.label }), jsx(MultiSelectCombobox, { options: [
                            { label: filter.presentLabel || 'Has value', value: 'present' },
                            { label: filter.absentLabel || 'Missing', value: 'absent' },
                        ], value: value ? [value] : [], onChange: (vals) => onChange(vals.length > 0 ? vals[vals.length - 1] : undefined), placeholder: `All` })] }));
        case 'daterange':
            return (jsxs("div", { className: "space-y-1.5", children: [jsx(Label, { className: "text-sm font-medium", children: filter.label }), jsxs("div", { className: "flex items-center gap-2", children: [jsx(DatePicker, { date: value?.from, onDateChange: date => onChange({ ...value, from: date?.toISOString() }), placeholder: "From", className: "flex-1" }), jsx(DatePicker, { date: value?.to, onDateChange: date => onChange({ ...value, to: date?.toISOString() }), placeholder: "To", className: "flex-1" })] })] }));
        default:
            return null;
    }
}

export { ListFilters };
//# sourceMappingURL=ListFilters.js.map
